"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customMapTypes = exports.markerSizedByType = exports.MarkerSizes = exports.markerIconsByType = exports.displayElementsSettings = exports.displayElementsLabels = exports.DisplayElementsVisibilities = void 0;
/// <reference types="@types/googlemaps" />
exports.DisplayElementsVisibilities = {
    off: 0,
    simplified: 1,
    on: 2,
};
exports.displayElementsLabels = {
    [exports.DisplayElementsVisibilities.off]: "off",
    [exports.DisplayElementsVisibilities.simplified]: "simplified",
    [exports.DisplayElementsVisibilities.on]: "on",
};
exports.displayElementsSettings = {
    roadmap: {
        labels: exports.DisplayElementsVisibilities.simplified,
        terrain: exports.DisplayElementsVisibilities.simplified,
        highways: exports.DisplayElementsVisibilities.on,
        roads: exports.DisplayElementsVisibilities.on,
        transit: exports.DisplayElementsVisibilities.off,
        poi: exports.DisplayElementsVisibilities.simplified,
        water: exports.DisplayElementsVisibilities.on,
    },
    satellite: {
        labels: exports.DisplayElementsVisibilities.simplified,
        terrain: exports.DisplayElementsVisibilities.simplified,
        highways: exports.DisplayElementsVisibilities.on,
        roads: exports.DisplayElementsVisibilities.off,
        transit: exports.DisplayElementsVisibilities.off,
        poi: exports.DisplayElementsVisibilities.off,
        water: exports.DisplayElementsVisibilities.on,
    },
    hybrid: {
        labels: exports.DisplayElementsVisibilities.simplified,
        terrain: exports.DisplayElementsVisibilities.simplified,
        highways: exports.DisplayElementsVisibilities.on,
        roads: exports.DisplayElementsVisibilities.on,
        transit: exports.DisplayElementsVisibilities.off,
        poi: exports.DisplayElementsVisibilities.off,
        water: exports.DisplayElementsVisibilities.on,
    },
    silver: {
        labels: exports.DisplayElementsVisibilities.on,
        terrain: exports.DisplayElementsVisibilities.simplified,
        highways: exports.DisplayElementsVisibilities.on,
        roads: exports.DisplayElementsVisibilities.on,
        transit: exports.DisplayElementsVisibilities.simplified,
        poi: exports.DisplayElementsVisibilities.simplified,
        water: exports.DisplayElementsVisibilities.on,
    },
    retro: {
        labels: exports.DisplayElementsVisibilities.on,
        terrain: exports.DisplayElementsVisibilities.simplified,
        highways: exports.DisplayElementsVisibilities.on,
        roads: exports.DisplayElementsVisibilities.on,
        transit: exports.DisplayElementsVisibilities.simplified,
        poi: exports.DisplayElementsVisibilities.simplified,
        water: exports.DisplayElementsVisibilities.on,
    },
};
exports.markerIconsByType = {
    marker: {
        path: "M5,0 C7.7614237,0 10,2.2385763 10,5 C10,7.2552838 8.5068336,9.16182 6.4551597,9.7849497 L5,18.3059082 L3.5945298,9.7997581 C1.5173194,9.1925133 0,7.2734511 0,5 C0,2.2385763 2.2385763,0 5,0 Z",
        viewBox: "0 0 10 19",
    },
    pin: {
        path: "M7,0 C10.866,0 14,3.134 14,7 C14,12 7,20 7,20 C7,20 0,12 0,7 C0,3.134 3.134,0 7,0 Z M7,4.5 C5.62,4.5 4.5,5.619 4.5,7 C4.5,8.381 5.62,9.5 7,9.5 C8.381,9.5 9.5,8.381 9.5,7 C9.5,5.619 8.381,4.5 7,4.5 Z",
        viewBox: "0 0 14 20",
    },
    circle: {
        path: "M 100, 100 m -75, 0 a 75,75 0 1,0 150,0 a 75,75 0 1,0 -150,0",
        viewBox: "0 0 200 200",
    },
};
exports.MarkerSizes = {
    small: "s",
    medium: "m",
    large: "l",
};
exports.markerSizedByType = {
    [exports.MarkerSizes.small]: ["10px", "14px"],
    [exports.MarkerSizes.medium]: ["14px", "20px"],
    [exports.MarkerSizes.large]: ["18px", "26px"],
};
exports.customMapTypes = {
    retro: [
        {
            elementType: "geometry",
            stylers: [
                {
                    color: "#ebe3cd",
                },
            ],
        },
        {
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#523735",
                },
            ],
        },
        {
            elementType: "labels.text.stroke",
            stylers: [
                {
                    color: "#f5f1e6",
                },
            ],
        },
        {
            featureType: "administrative",
            elementType: "geometry.stroke",
            stylers: [
                {
                    color: "#c9b2a6",
                },
            ],
        },
        {
            featureType: "administrative.land_parcel",
            elementType: "geometry.stroke",
            stylers: [
                {
                    color: "#dcd2be",
                },
            ],
        },
        {
            featureType: "administrative.land_parcel",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#ae9e90",
                },
            ],
        },
        {
            featureType: "landscape.natural",
            elementType: "geometry",
            stylers: [
                {
                    color: "#dfd2ae",
                },
            ],
        },
        {
            featureType: "poi",
            elementType: "geometry",
            stylers: [
                {
                    color: "#dfd2ae",
                },
            ],
        },
        {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#93817c",
                },
            ],
        },
        {
            featureType: "poi.park",
            elementType: "geometry.fill",
            stylers: [
                {
                    color: "#a5b076",
                },
            ],
        },
        {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#447530",
                },
            ],
        },
        {
            featureType: "road",
            elementType: "geometry",
            stylers: [
                {
                    color: "#f5f1e6",
                },
            ],
        },
        {
            featureType: "road.arterial",
            elementType: "geometry",
            stylers: [
                {
                    color: "#fdfcf8",
                },
            ],
        },
        {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [
                {
                    color: "#f8c967",
                },
            ],
        },
        {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [
                {
                    color: "#e9bc62",
                },
            ],
        },
        {
            featureType: "road.highway.controlled_access",
            elementType: "geometry",
            stylers: [
                {
                    color: "#e98d58",
                },
            ],
        },
        {
            featureType: "road.highway.controlled_access",
            elementType: "geometry.stroke",
            stylers: [
                {
                    color: "#db8555",
                },
            ],
        },
        {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#806b63",
                },
            ],
        },
        {
            featureType: "transit.line",
            elementType: "geometry",
            stylers: [
                {
                    color: "#dfd2ae",
                },
            ],
        },
        {
            featureType: "transit.line",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#8f7d77",
                },
            ],
        },
        {
            featureType: "transit.line",
            elementType: "labels.text.stroke",
            stylers: [
                {
                    color: "#ebe3cd",
                },
            ],
        },
        {
            featureType: "transit.station",
            elementType: "geometry",
            stylers: [
                {
                    color: "#dfd2ae",
                },
            ],
        },
        {
            featureType: "water",
            elementType: "geometry.fill",
            stylers: [
                {
                    color: "#b9d3c2",
                },
            ],
        },
        {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#92998d",
                },
            ],
        },
    ],
    silver: [
        {
            elementType: "geometry",
            stylers: [
                {
                    color: "#f5f5f5",
                },
            ],
        },
        {
            elementType: "labels.icon",
            stylers: [
                {
                    visibility: "off",
                },
            ],
        },
        {
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#616161",
                },
            ],
        },
        {
            elementType: "labels.text.stroke",
            stylers: [
                {
                    color: "#f5f5f5",
                },
            ],
        },
        {
            featureType: "administrative.land_parcel",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#bdbdbd",
                },
            ],
        },
        {
            featureType: "poi",
            elementType: "geometry",
            stylers: [
                {
                    color: "#eeeeee",
                },
            ],
        },
        {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#757575",
                },
            ],
        },
        {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [
                {
                    color: "#e5e5e5",
                },
            ],
        },
        {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#9e9e9e",
                },
            ],
        },
        {
            featureType: "road",
            elementType: "geometry",
            stylers: [
                {
                    color: "#ffffff",
                },
            ],
        },
        {
            featureType: "road.arterial",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#757575",
                },
            ],
        },
        {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [
                {
                    color: "#dadada",
                },
            ],
        },
        {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#616161",
                },
            ],
        },
        {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#9e9e9e",
                },
            ],
        },
        {
            featureType: "transit.line",
            elementType: "geometry",
            stylers: [
                {
                    color: "#e5e5e5",
                },
            ],
        },
        {
            featureType: "transit.station",
            elementType: "geometry",
            stylers: [
                {
                    color: "#eeeeee",
                },
            ],
        },
        {
            featureType: "water",
            elementType: "geometry",
            stylers: [
                {
                    color: "#c9c9c9",
                },
            ],
        },
        {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#9e9e9e",
                },
            ],
        },
    ],
};
